module.exports = __webpack_public_path__ + "img/my.c6ffabc2.svg";